/* tslint:disable */
/* eslint-disable */
/**
 * STRY API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    VideosAnswerFull,
    VideosAnswerFullFromJSON,
    VideosAnswerFullFromJSONTyped,
    VideosAnswerFullToJSON,
} from './';

/**
 * 
 * @export
 * @interface EducationAnswer
 */
export interface EducationAnswer {
    /**
     * 
     * @type {Array<VideosAnswerFull>}
     * @memberof EducationAnswer
     */
    educationalVideos?: Array<VideosAnswerFull>;
}

export function EducationAnswerFromJSON(json: any): EducationAnswer {
    return EducationAnswerFromJSONTyped(json, false);
}

export function EducationAnswerFromJSONTyped(json: any, ignoreDiscriminator: boolean): EducationAnswer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'educationalVideos': !exists(json, 'educational-videos') ? undefined : ((json['educational-videos'] as Array<any>).map(VideosAnswerFullFromJSON)),
    };
}

export function EducationAnswerToJSON(value?: EducationAnswer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'educational-videos': value.educationalVideos === undefined ? undefined : ((value.educationalVideos as Array<any>).map(VideosAnswerFullToJSON)),
    };
}


